// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_38TAU","button":"index_button_1Nz0Y"};